import React, { useState } from 'react';
import ModuloModule from './modulo/ModuloModule';
import UsuarioModule from './usuario/UsuarioModule';
import './CadastroModule.css';

interface CadastroModuleProps {
  onBackToDashboard?: () => void;
}

const CadastroModule: React.FC<CadastroModuleProps> = ({ onBackToDashboard }) => {
  const [activeTab, setActiveTab] = useState<'modulos' | 'usuarios'>('modulos');

  const tituloPagina = activeTab === 'usuarios' ? 'Cadastro de Usuários' : 'Cadastro de Módulos';

  return (
    <div className="cadastro-module">
      <div className="cadastro-topbar">
        <div className="cadastro-topbar-header">
          <h2>{tituloPagina}</h2>
          {onBackToDashboard && (
            <button className="cadastro-btn-back" onClick={onBackToDashboard}>
              &larr; Voltar ao Dashboard
            </button>
          )}
        </div>

        <div className="cadastro-tabs" role="tablist" aria-label="Abas de cadastro">
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === 'modulos'}
            className={`cadastro-tab ${activeTab === 'modulos' ? 'active' : ''}`}
            onClick={() => setActiveTab('modulos')}
          >
            Cadastro de Módulos
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === 'usuarios'}
            className={`cadastro-tab ${activeTab === 'usuarios' ? 'active' : ''}`}
            onClick={() => setActiveTab('usuarios')}
          >
            Cadastro de Usuários
          </button>
        </div>
      </div>

      {activeTab === 'modulos' && <ModuloModule />}
      {activeTab === 'usuarios' && <UsuarioModule />}
    </div>
  );
};

export default CadastroModule;